import { render, staticRenderFns } from "./RoleItem.vue?vue&type=template&id=18eb35f9"
import script from "./RoleItem.vue?vue&type=script&lang=js"
export * from "./RoleItem.vue?vue&type=script&lang=js"
import style0 from "./RoleItem.vue?vue&type=style&index=0&id=18eb35f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports